module.exports = __webpack_public_path__ + "img/logo_bkb_borobudur.ba4b8236.png";